module.exports = {
  titleCardOptions: {
    title: '专家介绍',
    showMore: false,
    isSwitch: false
  },
  resultDetails: [
    {
      title: '高级知识产权师',
      contents: [
        '单位：广州国际技术交易服务中心有限公司',
        '从事领域：产业发展服务保障□其他领域'
      ]
    },
    {
      title: '擅长研发的课题',
      contents: [
        '1、黄燕 钱茜茜 杨雄《浅析高价值专利的市场价值培育》（[J].智富时代,2019(1):63-64.',
        '2、黄燕 邵春.《我省科技人才数据库建设存在的问题及对策建议》（[J].广东科技,2012,21(13):1-1）',
        '3、周金霞 黄燕.《企业高层次科技人才培养模式探讨与研究》（[J].经济师,2015(11):250-251.）',
        '4、黄燕 杨薇 杨雄《高校科研院所专利产业化促进现实路径研究》（[J].科技视界,2019(28):54-55+36.）',
        '5、郑华丽 黄燕 杨雄《浅谈专利实用申请中关于客体问题审查意见的答复思路》（[J].科技创新发展战略研究,2019,3(06):54-57.）'
      ]
    },
    {
      title: '主要成就',
      contents: [
        `高级知识产权师、科技情报助理研究员、广州市高端专业服务业高端人才、广州市高级技术经纪人、全国专业技术人员创新创业导师、全国专业技术人员众创空间管理咨询导师、粤港澳
          大湾区高价值专利培育布局大赛评审专家、AMAC基金从业资格考试成绩合格证、广东圆梦园科技孵化有限公司创业导师、肇庆市登骏科技企业孵化器有限公司创业导师。`
      ]
    }
  ]
}